import React, { useEffect, useRef, useState } from 'react';
import { useField } from 'formik';
import Input from 'app/common/components/Elements/Input';
// import CaptchaCanvas from 'app/common/components/CaptchaCanvas';
import { CaptchaFieldProps } from './types';
import apiService from '../../../../../../bff/services/apiService';
import { SystemParamIdEnum, SystemParamTypesEnum } from '../../../../../../bff/enums/system';

const CaptchaField: React.FC<CaptchaFieldProps> = ({ wrapClassName, code, captchaImg, captchaSn, onRefresh, ...props }) => {
  const [field, meta, helpers] = useField(props.name);
  const [audioBaseUrl, setAudioBaseUrl] = useState<string | undefined>(undefined);
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const [audioUrl, setAudioUrl] = useState<string | undefined>(undefined);
  const audioRef = useRef<HTMLAudioElement>(null);

  /**
   * @description 初始組件
   */
  useEffect(() => {
    (async () => {
      const args = {
        paramType: SystemParamTypesEnum.BaseURL,
        paramId: SystemParamIdEnum.AudioUrl
      };
      // 取得 Captcha 音檔位置
      const response = await apiService.postInfoSysparams(args);
      if (response && response.length > 0) {
        if (response[0]) setAudioBaseUrl(response[0].paramValue);
      }
    })();
  }, []);

  /**
     * @description 處理重新產生
     */
  const handleRefresh = () => {
    if (onRefresh) onRefresh();
    helpers.setValue('');
  };

  const handleVideoPlay = async () => {
    console.log(`captchaSn: ${captchaSn}, audioBaseUrl: ${audioBaseUrl}`);
    if (!captchaSn || !audioBaseUrl) return;
    const response = await apiService.postAaCaptchaVoice({ captchaSn });
    console.log(`response: ${JSON.stringify(response)}`);

    if (response) {
      setIsPlaying(true);
      setAudioUrl(`${audioBaseUrl}${response.ccad}`);
      console.log(`Url: ${audioBaseUrl}${response.ccad}`);
      setTimeout(() => {
        if (audioRef.current) {
          try {
            audioRef.current.play();
            audioRef.current.onended = () => {
              setIsPlaying(false);
            };
          } catch (e) {
            console.error(e);
            setIsPlaying(false);
          }
        }
      }, 300);
    }
  };

  return (
    <div className={'col-12' + (wrapClassName ? ` ${wrapClassName}` : '')}>
      <div className="name">圖形驗證碼</div>
      <div className="img-verify">
        <Input id={props.name} tabIndex={props.tabIndex} aria-label={props.name} {...field} title="圖形驗證碼" type="text" className={(meta.error && meta.touched ? ' field--invalid' : '')} placeholder="請輸入驗證碼" />
        <div className="d-flex mt-2 align-items-end gap-2 flex-wrap">
          {/* <CaptchaCanvas width="135" height="34" code={code} /> */}
          <img className="ms-2" src={`data:image/jpeg;base64,${captchaImg}`} alt="captcha" />
          <button tabIndex={props.tabIndex} type="button" className="recreate style-none" onClick={handleRefresh} disabled={isPlaying}>
            <div className="style-none">重新產生</div>
            <img src={require('assets/img/icons/cycle.svg').default} className="cycle-icon" alt="refresh-icon" />
          </button>
          <button tabIndex={props.tabIndex} type="button" className="recreate style-none" onClick={handleVideoPlay} disabled={isPlaying}>
            <div className="style-none">語音播放</div>
            <img src={require('assets/img/icons/voice-play.svg').default} className="cycle-icon" alt="video-play" />
            {/* 離開此頁後自動銷毀 */}
            <audio ref={audioRef} src={audioUrl} />
          </button>
        </div>
      </div>

      {meta.error && meta.touched && (
        <div className="notes warn mt-2">{meta.error}</div>
      )}
    </div>
  );
};

export default CaptchaField;
